export const initialDateRange = {
    from: undefined,
    to: undefined,
};
